
import { computed, defineComponent, onMounted, ref } from 'vue'
import axios from 'axios'
import apiConfig from '../api/api.json'
import defaultAvatar from '../assets/images/img.png'
import spaceLogo from '../assets/images/bilibili-space-logo.svg'
import liveLogo from '../assets/images/bilibili-live-logo.png'
import config from '../config'

interface UserInfo {
  name: string
  face: string
  notice: string
  pendant: string
  follower: number | null
}

const defaultUserInfo: UserInfo = {
  name: '一杯吃吃',
  face: defaultAvatar,
  notice: 'Loading...',
  pendant: '',
  follower: null
}

const formatFollower = (count: number | null) => {
  if (count === null || count === undefined) return '--'
  if (count >= 10000) {
    const wan = count / 10000
    const text = wan >= 100 ? String(Math.round(wan)) : wan.toFixed(1).replace(/\.0$/, '')
    return `${text}万`
  }
  return count.toLocaleString('en-US')
}

const formatFollowerExact = (count: number | null) => {
  if (count === null || count === undefined) return ''
  return count.toLocaleString('en-US')
}

const __default__ = defineComponent({
  name: 'ProfilePanel',
  setup() {
    const userInfo = ref<UserInfo>(defaultUserInfo)
    const followerExact = computed(() => formatFollowerExact(userInfo.value.follower))

    const fetchUserData = async () => {
      try {
        const { url, params } = apiConfig.bilibili.userCard
        const { url: apiUrl, params: apiParams } = config.getApiUrl(url, params)
        const response = await axios.get(apiUrl, {
          params: apiParams,
          withCredentials: false
        })

        if (response.data.code === 0) {
          const userData = response.data.data
          userInfo.value = {
            name: userData.card.name || defaultUserInfo.name,
            face: userData.card.face || defaultUserInfo.face,
            notice: userData.card.sign || defaultUserInfo.notice,
            pendant: userData.card.pendant?.image || '',
            follower: typeof userData.follower === 'number' ? userData.follower : null
          }
        } else {
          userInfo.value = defaultUserInfo
        }
      } catch {
        userInfo.value = defaultUserInfo
      }
    }

    onMounted(() => {
      fetchUserData()
    })

    const handleAvatarClick = () => {
      const avatar = document.querySelector('.avatar') as HTMLElement
      if (avatar) {
        avatar.style.animation = 'none'
        avatar.offsetHeight
        avatar.style.animation = 'avatarPop 0.5s ease'
      }
      setTimeout(() => {
        window.open('https://space.bilibili.com/335573347', '_blank')
      }, 0)
    }

    return {
      userInfo,
      formatFollower,
      followerExact,
      handleAvatarClick,
      spaceLogo,
      liveLogo
    }
  }
})

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "fb96a82a": (!_ctx.userInfo.pendant ? "block" : "none")
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__